import type { TradeRecord } from '../types/position';

/**
 * Sort trades by timestamp ascending, with trade_id as tiebreaker
 * for deterministic ordering when timestamps are equal.
 */
export function sortTrades(trades: TradeRecord[]): TradeRecord[] {
  return [...trades].sort((a, b) => {
    const timeCompare = a.timestamp.localeCompare(b.timestamp);
    if (timeCompare !== 0) return timeCompare;
    return a.trade_id.localeCompare(b.trade_id);
  });
}

/**
 * Returns the trade source display value.
 * If the value is a non-empty string, returns it verbatim.
 * If null, undefined, or empty string, returns "—" (em dash).
 */
export function getTradeSourceDisplay(tradeSource?: string | null): string {
  if (tradeSource != null && tradeSource !== '') {
    return tradeSource;
  }
  return '\u2014';
}
